var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 5.89323H10.8327V7.5599H9.16602V5.89323ZM9.16602 9.22656H10.8327V14.2266H9.16602V9.22656ZM9.99935 1.72656C5.39935 1.72656 1.66602 5.4599 1.66602 10.0599C1.66602 14.6599 5.39935 18.3932 9.99935 18.3932C14.5993 18.3932 18.3327 14.6599 18.3327 10.0599C18.3327 5.4599 14.5993 1.72656 9.99935 1.72656ZM9.99935 16.7266C6.32435 16.7266 3.33268 13.7349 3.33268 10.0599C3.33268 6.3849 6.32435 3.39323 9.99935 3.39323C13.6743 3.39323 16.666 6.3849 16.666 10.0599C16.666 13.7349 13.6743 16.7266 9.99935 16.7266Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c74306ebd5946e4ad30cdbd32519c914.svg";
export { ForwardRef as ReactComponent };